module.exports = __webpack_public_path__ + "static/media/screen-facebook-MW.6852ab4a.png";